import PageViewedSystemEvent, { pageViewedSystemEventName } from './PageViewedSystemEvent';
import withPageViewSystemEventPublisher from './withPageViewSystemEventPublisher';

export default withPageViewSystemEventPublisher;
export { pageViewedSystemEventName, PageViewedSystemEvent };
